import { useContext, useLayoutEffect, useState } from "react";
import { Language } from "./Context";

export const languages = [
	"en",
	"cs",
	"pg",
	"es"
] as const;
export const langNames = [
	"English",
	"Čeština",
	"Português",
	"Español"
] as const;

export type LanguageCode = typeof languages[number];
export function IsLanguageCode(code: unknown): code is LanguageCode {
  return languages.some(v => v === code);
}

export type Glob<T> = {[index in LanguageCode] : T}
export function Glob<keys extends string, P extends { [K in keys]: unknown }>(val: { [l in LanguageCode]: P }) {
  return val;
}
export type Loc<T extends Glob<any>> = T extends Glob<infer L> ? L : never;

export function useLoc<T>(glob: Glob<T>) {
  const lng = useContext(Language);
  const [loc, setLoc] = useState<T>(glob[lng]);
  useLayoutEffect(() => {
    setLoc(glob[lng] || glob.en);
  }, [lng]);
  return loc;
}

export const timeGlob = Glob({
	en: {
		monthNames : ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
		monthLabel(d : Date) : string {
			return `${this.monthNames[d.getMonth()]} ${d.getFullYear()}`;
		},
		dayLabel(d : Date) : string {
			return `${this.monthNames[d.getMonth()]} ${d.getDate()}`;
		},
		dateLabel(d : Date) : string {
			return `${this.monthNames[d.getMonth()]} ${d.getDate()} ${d.getFullYear()}`
		}
	},
	cs: {
		monthNames : ["Leden", "Únor", "Březen", "Duben", "Květen", "Červen", "Červenec", "Srpen", "Září", "Říjen", "Listopad", "Prosinec"],
		monthLabel(d : Date) : string {
			return `${this.monthNames[d.getMonth()]} ${d.getFullYear()}`;
		},
		dayLabel(d : Date) : string {
			return `${d.getDate()}. ${d.getMonth() + 1}.`;
		},
		dateLabel(d : Date) : string {
			return `${d.getDate()}. ${d.getMonth() + 1}. ${d.getFullYear()}`
		}
	},
	pg: {
		monthNames: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
		monthLabel(d : Date) : string {
			return `${this.monthNames[d.getMonth()]} de ${d.getFullYear()}`;
		},
		dayLabel(d : Date) : string {
			return `${d.getDate()}/${d.getMonth() + 1}`;
		},
		dateLabel(d : Date) : string {
			return `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()}`
		}
	},
	es: {
		monthNames: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diecembre"],
		monthLabel(d : Date) : string {
			return `${this.monthNames[d.getMonth()]} de ${d.getFullYear()}`;
		},
		dayLabel(d : Date) : string {
			return `${d.getDate()}/${d.getMonth() + 1}`;
		},
		dateLabel(d : Date) : string {
			return `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()}`
		}
	}
} as const);

